import { render, staticRenderFns } from "./TaskDefinitionCreate.vue?vue&type=template&id=55262932&"
import script from "./TaskDefinitionCreate.vue?vue&type=script&lang=js&"
export * from "./TaskDefinitionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports